// src/sites/Privacy.jsx
import React from "react";
import { useI18n } from "../I18nProvider";
import "./styles.css";

export default function Privacy() {
  const { t } = useI18n();

  return (
    <>

        <br></br><br></br><br></br>
      <section id="services" className="services">
        <div className="container">
          <h2>{t("privacy.title")}</h2>

          <div
            className="privacy-content"
            // Wir rendern den von dir gepflegten HTML-Block aus translations.js
            dangerouslySetInnerHTML={{ __html: t("privacy.html") }}
          />
        </div>
      </section>
    </>
  );
}
